/* istanbul ignore file */
import React from 'react';

import { get as getConstants } from '@lumapps/constants';
import { connect } from '@lumapps/redux/react';
import { FrontOfficeStore } from '@lumapps/redux/types';
import { hasAcceptedCookiesSelector, userIdSelector, wasUserInitialized } from '@lumapps/user/ducks/selectors';

import { saveUserCookiesPreferences } from '../../ducks/thunks';
import { GdprBanner, GdprBannerInterface } from './GdprBanner';

const constants = getConstants();

const mapStateToProps = (state: FrontOfficeStore) => ({
    hasAcceptedCookies: hasAcceptedCookiesSelector(state),
    userId: userIdSelector(state),
    initialized: wasUserInitialized(state),
});

const mapDispatchToProps = {
    saveUserCookiesPreferences,
};

const ConnectedGdprBanner = connect(
    mapStateToProps,
    mapDispatchToProps,
)(({ initialized, ...props }: GdprBannerInterface & { initialized?: boolean }) => {
    return !constants.isLegacyContext || initialized ? <GdprBanner {...props} /> : null;
});

export { ConnectedGdprBanner as GdprBanner };
